export default __webpack_public_path__ + "static/media/projetoSertao.aa65757b.jpg";